import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from '@core/services/auth';
import { WelcomeNavbar } from '@shared/components/navigation/components/welcome-navbar/welcome-navbar';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { FormLogin } from './form-login/form-login';

@Component({
  selector: 'app-login',
  imports: [
    InputTextModule,
    PasswordModule,
    ButtonModule,
    WelcomeNavbar,
    FormLogin,
  ],
  templateUrl: './login.html',
  styleUrl: './login.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Login implements OnInit {
  private router = inject(Router);
  private auth = inject(Auth);

  ngOnInit(): void {
    this.auth.getCurrentUserWithProfile().then(session => {
      if (session?.user != null && session.profile.role != 'user') {
        // Verificar si hay una URL de retorno guardada
        const returnUrl = sessionStorage.getItem('returnUrl');

        if (returnUrl) {
          // Limpiar el sessionStorage y redirigir a la URL original
          sessionStorage.removeItem('returnUrl');
          this.router.navigateByUrl(returnUrl);
        } else {
          // Si no hay URL guardada, ir a la página principal
          this.router.navigate(['/']);
        }
      }
    });
  }
}
